package com.appsyde.shared.modules.auth.data

import kotlinx.serialization.Serializable

/** Réponse API /auth/login (miroir serveur). */
@Serializable
data class AuthLoginResponse(val authUrl: String)

/** Réponse API /auth/session-token. */
@Serializable
data class SessionTokenResponse(val accessToken: String)
